/**
 * A wrapper over `Object.keys()`
 * @returns an array of a given object's own enumerable property names, iterated in the same order that a normal loop would.
 */
function keys<T>(obj: T) {
    return Object.keys(obj) as (keyof T)[];
}

export default keys;
